import { Auth, AuthAction, USER_LOGIN, USER_LOGOUT } from '../actions/auth';
import { AuthRepository } from 'infraestructure/repositories';

const initialState: Auth = {
  isLogged: false,
  authLoading: true,
};

export const AUTH_RESTORE = 'AUTH_RESTORE';

export const authReducer = (
  state: Auth = initialState,
  action: AuthAction & { type: string; payload?: any }
): Auth => {
  switch (action.type) {
    case USER_LOGIN:
      return { ...state, isLogged: true, authLoading: false };
    case USER_LOGOUT:
      new AuthRepository().removeToken();
      return { ...state, isLogged: false, authLoading: false };
    case AUTH_RESTORE:
      return { ...state, isLogged: action.payload.isLogged, authLoading: false };
    default:
      return state;
  }
};
